exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chart-font[data-v-c4ff1f4a] {\n    font-size: 12px;\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    color: #666;\n}\n", ""]);

// exports
